export default "__VITE_PUBLIC_ASSET__4e931465__"